import { useState } from 'react';
import { blogArticles, blogCategories } from '../../../mocks/blog';

export default function BlogSection() {
  const [activeCategory, setActiveCategory] = useState('Tümü');
  const allCats = ['Tümü', ...blogCategories];
  const filtered = activeCategory === 'Tümü' ? blogArticles : blogArticles.filter(a => a.category === activeCategory);

  return (
    <section id="blog" className="py-20 md:py-28 bg-cream">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <span className="text-xs font-medium tracking-[0.2em] text-gold uppercase mb-3 block">Makaleler & Blog</span>
          <h2 className="font-serif text-3xl md:text-4xl font-light text-warm-dark mb-4">Okuma köşesi</h2>
          <p className="text-warm-mid text-sm max-w-md mx-auto">Aile, ilişkiler ve psikoloji hakkında uzman görüşleri ve rehber yazılar.</p>
        </div>
        <div className="flex flex-wrap justify-center gap-2 mb-10">
          {allCats.map(cat => (
            <button key={cat} onClick={() => setActiveCategory(cat)}
              className={`px-4 py-1.5 rounded-full text-xs font-medium transition-colors cursor-pointer whitespace-nowrap ${
                activeCategory === cat ? 'bg-gold text-white' : 'bg-white text-warm-mid border border-cream-deeper hover:border-gold hover:text-gold'
              }`}>
              {cat}
            </button>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {filtered.map(article => (
            <article key={article.id} className="bg-white rounded-2xl overflow-hidden border border-cream-deeper hover:border-gold/30 transition-all duration-300 group cursor-pointer">
              <div className="w-full h-48 overflow-hidden">
                <img src={article.image} alt={article.title} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-5 md:p-6">
                <div className="flex items-center justify-between mb-3">
                  <span className="text-xs font-medium text-gold bg-gold-pale px-2.5 py-1 rounded-full">{article.category}</span>
                  <span className="text-xs text-warm-light">{article.readTime} okuma</span>
                </div>
                <h3 className="font-serif text-lg font-medium text-warm-dark mb-2 leading-snug group-hover:text-gold transition-colors">{article.title}</h3>
                <p className="text-sm text-warm-light leading-relaxed line-clamp-3">{article.preview}</p>
                <div className="flex items-center justify-between mt-4 pt-4 border-t border-cream-deeper">
                  <span className="text-xs text-warm-light">{article.date}</span>
                  <span className="text-xs font-medium text-gold flex items-center gap-1">Devamını oku <i className="ri-arrow-right-line" /></span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}